import { useState } from "react";
import { useTranslation } from "react-i18next";
import { Link, useSearchParams } from "react-router-dom";

import { Pagination, usePagination } from "../../../components/Pagination";
import { useQuoteRequestsByProject } from "../../../lib/queries/quoteRequests";

/** Lists existing request cycles, without selecting or inventing one. */
export function ComparisonCyclePicker({ projectId }: { projectId: string }) {
  const { t, i18n } = useTranslation();
  const [open, setOpen] = useState(false);
  const [params] = useSearchParams();
  const page = usePagination();
  const query = useQuoteRequestsByProject({
    projectId,
    cursor: page.cursor,
    limit: 10,
    enabled: open,
  });
  const items = query.data?.items ?? [];
  return (
    <details className="mt-2 text-sm" onToggle={(event) => setOpen(event.currentTarget.open)}>
      <summary className="cursor-pointer underline">{t("reception_flow.choose_cycle")}</summary>
      {query.isLoading && <p role="status">{t("app.loading")}</p>}
      {query.error && <p role="alert">{t("errors.generic")}</p>}
      {!query.error && (
        <ul className="my-2 space-y-2">
          {items.map((request) => (
            <li key={request.id}>
              <Link
                className="underline"
                aria-current={params.get("quote_request_id") === request.id ? "page" : undefined}
                to={`/projects/${projectId}/comparison?quote_request_id=${request.id}${params.get("show_hidden") === "1" ? "&show_hidden=1" : ""}`}
              >
                {request.title ?? t("reception_flow.request")} ·{" "}
                {new Date(request.created_at).toLocaleDateString(i18n.resolvedLanguage)}
              </Link>
            </li>
          ))}
        </ul>
      )}
      <Pagination
        pageNumber={page.pageNumber}
        hasPrev={page.hasPrev}
        hasNext={!!query.data?.next_cursor && !query.error}
        onPrev={page.prev}
        onNext={() => page.next(query.data?.next_cursor ?? null)}
        disabled={query.isFetching}
      />
    </details>
  );
}
